import {
    Box,
    Button,
    DialogActions,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@material-ui/core";
import React, {useState} from "react";
import {t} from "i18next";
import {Room} from "../../API";
import {IOrgUnit} from "../../hooks/useOrgunit";
import {comparatorAlphanumericValues} from "../../Utils/Helpers";
import {TextField} from "@mui/material";

interface Props {
    orgUnitList: IOrgUnit[];
    assignedRooms: Room[];
    setAssignedRooms: (value: Room[]) => void;
    availableRooms: Room[]
    setAvailableRooms: (value: Room[]) => void
    addUpdatedRoomsIds: (value: string)=> void
}

const ManageBuildingAssignedRoomsComponent: React.FC<Props> = (props) => {
    const {orgUnitList, assignedRooms, setAssignedRooms,addUpdatedRoomsIds,
        availableRooms, setAvailableRooms} = props;
    const [selectedRoom, setSelectedRoom] = useState<Room | null>(null);
    const [floorInput,setFloorInput] = useState<string>("")


    const sortRoomsListByFloor = (rooms: (Room | null)[]) => {
        return rooms.sort((roomOne: Room | null, roomTwo: Room | null) => {
            const floorOne = roomOne!.floor!.toString();
            const floorTwo = roomTwo!.floor!.toString();
            const compareFloorResult = comparatorAlphanumericValues(floorOne, floorTwo);

            // TODO remove org unit
            if (compareFloorResult === 0 && roomOne!.orgUnitId && roomTwo!.orgUnitId) {
                const orgUnitOne = orgUnitList.find(orgUnit => orgUnit.orgId === roomOne!.orgUnitId)!.orgName
                const orgUnitTwo = orgUnitList.find(orgUnit => orgUnit.orgId === roomTwo!.orgUnitId)!.orgName
                const compareOrgUnitResult = comparatorAlphanumericValues(orgUnitOne, orgUnitTwo);

                if (compareOrgUnitResult === 0) {
                    const nameOne = roomOne!.nameLowerCased;
                    const nameTwo = roomTwo!.nameLowerCased
                    return comparatorAlphanumericValues(nameOne, nameTwo);
                }

                return compareOrgUnitResult;
            } else if (compareFloorResult === 0 && (roomOne!.orgUnitId === null || roomTwo!.orgUnitId === null)) {
                const nameOne = roomOne!.nameLowerCased;
                const nameTwo = roomTwo!.nameLowerCased
                return comparatorAlphanumericValues(nameOne, nameTwo);
            }
            return compareFloorResult;
        });
    };

    const handleRemoveEntry = () => {

        // @ts-ignore
        const selectedRoomWithoutBuildingId: Room = {
            ...selectedRoom,
            buildingId: null,
            floor: 0, //Set to default value
        }

        const newAssignedRooms = assignedRooms.filter(room => room?.roomId !== selectedRoom?.roomId);
        const newAvailableRooms = [...availableRooms, selectedRoomWithoutBuildingId];

        setAssignedRooms(newAssignedRooms)
        setAvailableRooms(newAvailableRooms)
        if(selectedRoom){
            addUpdatedRoomsIds(selectedRoom?.roomId)
        }
        setSelectedRoom(null);

    };

    const handleFloorInput = (event:React.ChangeEvent<HTMLInputElement>) =>{
        setFloorInput(event.target.value)
    }
    const saveEditFloor = ()=>{
        const newRooms = assignedRooms.map(room => {
           if(room.roomId === selectedRoom?.roomId && !Number.isNaN(floorInput)){
               const newRoom = {...room}
               newRoom.floor = Number(floorInput)
               return newRoom
           }
           return room
       })
        setAssignedRooms(newRooms)
       if(selectedRoom){
           addUpdatedRoomsIds(selectedRoom?.roomId)
       }
    }
    const renderFloorCell = (room:Room|null)=>{
            return (
                <TextField
                    id={room!.roomId + "-floor"}
                    data-testid={room!.roomId + "-floor"}
                    label="Number"
                    type="number"
                    onChange={handleFloorInput}
                    onBlur={saveEditFloor}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    variant="standard"
                    placeholder={room!.floor?.toString()}
                />
            )

    }
    return (
        <Box>
            <TableContainer style={{maxHeight: "440px", margin: "25px 0px", tableLayout: "fixed"}}>
                <Table stickyHeader data-testid={"room-manager-table"} style={{margin: "0px", maxWidth: "100%"}}>
                    <TableHead>
                        <TableRow>
                            <TableCell data-testid={"floor-column"}>
                                {t("building-floor-column")}
                            </TableCell>
                            <TableCell data-testid={"room-plan-name-column"}>
                                {t("building-room-plan-name-column")}
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody data-testid={"building-list"}>
                        {sortRoomsListByFloor(assignedRooms).map((room: Room | null, index: number) => (
                            <TableRow
                                data-testid={`room-${index}`}
                                key={"room" + room?.roomId} // Use room.buildingId here
                                style={{cursor: "pointer"}}
                                onClick={() => setSelectedRoom(room)}
                                onFocus={()=> setSelectedRoom(room)}
                                selected={assignedRooms[index] === selectedRoom} // You might need to adjust this condition based on your use case
                            >
                                <TableCell
                                    key={"floor" + room?.roomId}
                                    style={{maxWidth: "200px"}}
                                >
                                    {renderFloorCell(room)}
                                </TableCell>
                                <TableCell
                                    key={"name" + room?.roomId}
                                    style={{maxWidth: "150px", wordBreak: "break-word"}}
                                >
                                    {room?.name}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <DialogActions style={{display: "flex", justifyContent: "flex-end"}}>
                <Button
                    onClick={() => handleRemoveEntry()}
                    color={"primary"}
                    variant={"contained"}
                    disabled={!selectedRoom}
                    data-testid={"manage-building-remove-btn"}
                >
                    {t("building-remove-button")}
                </Button>
            </DialogActions>
        </Box>
    );
};

export default ManageBuildingAssignedRoomsComponent; // Corrected export statement
